import React from "react";
import Palette from "../Palette/Palette";
var Footer = function () { return (React.createElement("footer", { className: "footer" },
    React.createElement("div", { className: "footer__container" }, "Sukrut Nadigotti \u00A9 ".concat(new Date().getFullYear()),
        React.createElement(Palette, null),
        React.createElement("p", { className: "footer__credits" }, "What's with the llama? It's my favorite animal!")))); };
export default Footer;
